import { Target, Crosshair, Circle, Flame, Music, Home, Tv, ShoppingBag, Crown } from "lucide-react";

export const ICON_MAP = { Target, Crosshair, Circle, Flame, Music, Home, Tv, ShoppingBag, Crown };

export const NAV_LINKS = [
  { path: "/", label: "Startseite" },
  { path: "/kalender", label: "Kalender" },
  { path: "/neuigkeiten", label: "Neuigkeiten" },
  { path: "/galerie", label: "Galerie" },
  { path: "/getraenkekarte", label: "Getränkekarte" },
  { path: "/shop", label: "Niners-Shop" },
  { path: "/reservierung", label: "Reservierung" },
];
